import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";

interface VoteItemProps {
    text: string;
    count: number;
    total: number;
}

export default function VoteItem({ text, count, total }: VoteItemProps) {
    return (
        <div className={style.root}>
            <div
                className={classNames(style.alphabet, {
                    [style.alphabetSmall]: text.length > 1
                })}>
                {text}
            </div>

            <div className={style.process}>
                <div
                    className={style.bar}
                    style={{
                        width: `${(Math.min(count, total) * 100) / total}%`
                    }}
                />
            </div>

            <div className={style.count}>{count}票</div>
        </div>
    );
}
